var _defs, _g, _g2, _g3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1_copy",
    "data-name": "Group 1 copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 510,
    viewBox: "0 0 1000 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff000;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #313942;\n      }\n\n      .cls-3 {\n        font-size: 78.333px;\n        fill: #231f21;\n        text-anchor: middle;\n        font-family: Poppins;\n        font-weight: 800;\n        text-transform: uppercase;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_copy",
    "data-name": "Rectangle 1 copy",
    className: "cls-1",
    d: "M-38.157,578.866L1372.99,706.722,1360.18,755-50.968,627.145Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M85.835,591.164l23.524,2.131L82.848,639.27l-23.524-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-2",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M134.5,595.573l23.524,2.131-26.511,45.974-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-3",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M183.155,599.982l23.524,2.131-26.511,45.974-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_9",
    "data-name": "Rectangle 2 copy 9",
    className: "cls-2",
    d: "M-58.165,578.164l23.524,2.131L-61.152,626.27l-23.524-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_9-2",
    "data-name": "Rectangle 2 copy 9",
    className: "cls-2",
    d: "M39.156,586.982l23.524,2.131L36.168,635.087l-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-4",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M231.816,604.391l23.523,2.131L228.828,652.5l-23.523-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-5",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M280.476,608.8L304,610.931l-26.511,45.974-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-6",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M329.136,613.208l23.524,2.132-26.511,45.974-23.524-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-7",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M377.8,617.617l23.524,2.131-26.511,45.975-23.524-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-8",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M426.457,622.026l23.523,2.131-26.511,45.974L399.946,668Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-9",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M475.117,626.435l23.524,2.131L472.13,674.54l-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-10",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M523.777,630.844l23.524,2.131L520.79,678.949l-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-11",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M572.437,635.252l23.524,2.132L569.45,683.358l-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-12",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M621.1,639.661l23.523,2.132L618.11,687.767l-23.523-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-13",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M669.758,644.07l23.524,2.131-26.511,45.975-23.524-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-14",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M718.418,648.479l23.524,2.131-26.511,45.974-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-15",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M767.078,652.888l23.524,2.131-26.511,45.974-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-16",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M815.739,657.3l23.523,2.131L812.751,705.4l-23.523-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-17",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M864.4,661.706l23.524,2.131-26.511,45.974-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-18",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M913.059,666.114l23.524,2.132L910.072,714.22l-23.524-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-19",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M961.719,670.523l23.524,2.132-26.511,45.974L935.208,716.5Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-20",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M1010.38,674.932l23.52,2.131-26.51,45.975-23.521-2.132Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-21",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M1059.04,679.341l23.52,2.131-26.51,45.974-23.52-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-22",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M1107.7,683.75l23.52,2.131-26.51,45.974-23.52-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-23",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M1156.36,688.159l23.52,2.131-26.51,45.974-23.52-2.131Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_8-24",
    "data-name": "Rectangle 2 copy 8",
    className: "cls-2",
    d: "M1205.02,692.567l23.52,2.132-26.51,45.974-23.52-2.131Z",
    transform: "translate(0 -245)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-120.844,563.948L1259.81,244.985l2.92,49.959L-117.93,613.907Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0.8,536.935l23.015-5.317L12.994,583.66l-23.015,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy",
    "data-name": "Rectangle 2 copy",
    className: "cls-2",
    d: "M48.411,525.936l23.015-5.317L60.6,572.662l-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M96.02,514.937l23.015-5.317-10.823,52.043L85.2,566.98Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_3",
    "data-name": "Rectangle 2 copy 3",
    className: "cls-2",
    d: "M143.628,503.939l23.016-5.317-10.823,52.042-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_4",
    "data-name": "Rectangle 2 copy 4",
    className: "cls-2",
    d: "M191.237,492.94l23.016-5.317L203.43,539.665l-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_5",
    "data-name": "Rectangle 2 copy 5",
    className: "cls-2",
    d: "M238.846,481.941l23.016-5.317-10.824,52.043-23.015,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M286.455,470.942l23.016-5.317-10.824,52.043-23.015,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-2",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M334.064,459.944l23.015-5.317-10.823,52.042-23.015,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-3",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M381.673,448.945l23.015-5.317L393.865,495.67l-23.015,5.318Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-4",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M429.282,437.946l23.015-5.317-10.823,52.043-23.015,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-5",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M476.891,426.948l23.015-5.318-10.823,52.043-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-6",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M524.5,415.949l23.015-5.317-10.823,52.042-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M572.108,404.95l23.016-5.317L584.3,451.676l-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-2",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M619.717,393.951l23.016-5.317L631.91,440.677l-23.016,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-3",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M667.326,382.953l23.016-5.317-10.824,52.042L656.5,435Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-4",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M714.935,371.954l23.015-5.317-10.823,52.042L704.112,424Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-5",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M762.544,360.955l23.015-5.317-10.823,52.043L751.721,413Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-6",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M810.153,349.956l23.015-5.317-10.823,52.043L799.33,402Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-7",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M857.762,338.958l23.015-5.317-10.823,52.042L846.939,391Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-8",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M905.371,327.959l23.015-5.317-10.823,52.042L894.547,380Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-9",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M952.979,316.96L976,311.643l-10.823,52.043L942.156,369Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-10",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1000.59,305.962l23.01-5.318-10.82,52.043L989.765,358Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-11",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1048.2,294.963l23.01-5.317-10.82,52.042-23.02,5.317Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-12",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1095.81,283.964l23.01-5.317L1108,330.69l-23.02,5.317Z",
    transform: "translate(0 -245)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-104.395,447.143L1304.19,601.228l-13.7,48.129L-118.094,495.272Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-225.643,434.729l23.481,2.569-27.355,45.567L-253,480.3Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy-2",
    "data-name": "Rectangle 2 copy",
    className: "cls-2",
    d: "M-177.071,440.042l23.481,2.569-27.355,45.567-23.481-2.568Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2-2",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M-128.5,445.355l23.481,2.569-27.355,45.568-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-13",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1186.36,589.337l23.48,2.568-27.36,45.568L1159,634.9Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-14",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1234.93,594.65l23.48,2.569-27.35,45.567-23.49-2.568Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_3-2",
    "data-name": "Rectangle 2 copy 3",
    className: "cls-2",
    d: "M-79.928,450.669l23.481,2.568L-83.8,498.805l-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_4-2",
    "data-name": "Rectangle 2 copy 4",
    className: "cls-2",
    d: "M-31.356,455.982l23.481,2.569-27.355,45.567L-58.71,501.55Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_5-2",
    "data-name": "Rectangle 2 copy 5",
    className: "cls-2",
    d: "M17.216,461.3L40.7,463.864,13.342,509.432l-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-7",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M65.788,466.609l23.481,2.568L61.914,514.745l-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-8",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M114.36,471.922l23.48,2.568-27.354,45.568L87,517.49Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-9",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M162.931,477.235l23.481,2.569-27.354,45.567L135.577,522.8Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-10",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M211.5,482.548l23.481,2.569-27.355,45.568-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-11",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M260.075,487.862l23.481,2.568L256.2,536l-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_6-12",
    "data-name": "Rectangle 2 copy 6",
    className: "cls-2",
    d: "M700.639,536.2l23.481,2.569L696.765,584.34l-23.481-2.568Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-15",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M749.211,541.517l23.481,2.569-27.355,45.568-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-16",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M797.783,546.831l23.481,2.568-27.355,45.568L770.428,592.4Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-17",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M846.355,552.144l23.48,2.568L842.481,600.28,819,597.712Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-18",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M894.926,557.457l23.481,2.569-27.354,45.567-23.481-2.568Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-19",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M943.5,562.77l23.481,2.569-27.355,45.568-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-20",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M992.07,568.084l23.48,2.568L988.2,616.22l-23.481-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-21",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1040.64,573.4l23.48,2.569-27.35,45.567-23.48-2.568Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-22",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1089.21,578.71l23.48,2.569-27.35,45.568-23.48-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-23",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1137.79,584.024l23.48,2.568-27.36,45.568-23.48-2.569Z",
    transform: "translate(0 -245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_7-24",
    "data-name": "Rectangle 2 copy 7",
    className: "cls-2",
    d: "M1136.5,583.953l23.48,2.568-27.35,45.568-23.48-2.569Z",
    transform: "translate(0 -245)"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "UNDER_Construction",
    "data-name": "UNDER Construction",
    className: "cls-3",
    transform: "matrix(0.393, 0.045, -0.045, 0.394, 476.445, 303.892)"
  }, "UNDER Construction")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConstruction);
export default __webpack_public_path__ + "static/media/img-construction.87c7d690cb73156ea10f0eba1b34b7b2.svg";
export { ForwardRef as ReactComponent };